import { render, staticRenderFns } from "./PopupNGFLGModal.vue?vue&type=template&id=20116215&scoped=true&"
import script from "./PopupNGFLGModal.vue?vue&type=script&lang=js&"
export * from "./PopupNGFLGModal.vue?vue&type=script&lang=js&"
import style0 from "./PopupNGFLGModal.vue?vue&type=style&index=0&id=20116215&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20116215",
  null
  
)

export default component.exports